import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const ProjectCard = makeShortcode("ProjectCard");
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h2>{`Projects`}</h2>
    <ProjectCard title="App Cluster" link="https://app-cluster-3m09.onrender.com/" bg="linear-gradient(to right, #D4145A 0%, #FBB03B 100%)" mdxType="ProjectCard">
This is the collection of applications I've made through ReactJS
    </ProjectCard>
    <ProjectCard title="Sorting Visualizer" link="https://app-cluster-3m09.onrender.com/sorting-visualizer" bg="linear-gradient(to right, #672d8c 0%, #ec1f7a 100%)" mdxType="ProjectCard">
This is a Visualizer for various sorting algorithms in ReactJS
    </ProjectCard>
    <ProjectCard title="Banking System(Grip)" link="https://github.com/sv-shivansh/grip-banking-app/" bg="linear-gradient(to right, #360033 0%, #0b8793 100%)" mdxType="ProjectCard">
Full Stack MERN application developed in internship under The Sparks Foundation
    </ProjectCard>
    <ProjectCard title="ToDo List Using Firebase" link="https://github.com/sv-shivansh/todo-firebase-js/" bg="linear-gradient(to right, #544a7d 0%, #ffd452 100%)" mdxType="ProjectCard">
Developed with HTML,CSS and JS with Google Firebase as a realtime Database.
    </ProjectCard>
    <ProjectCard title="Full Stack Event Registration forms" link="https://github.com/sv-shivansh/zigbee-recruitement" bg="linear-gradient(to right, #654ea3 0%, #eaafc8 100%)" mdxType="ProjectCard">
Developed with MERN for participant Registration with Validation and great UI Experience.
    </ProjectCard>
    <ProjectCard title="NoteLog" link="https://github.com/sv-shivansh" bg="linear-gradient(to right, #4b1248 0%, #e74c3c 100%)" mdxType="ProjectCard">
Application developed on Django to serves the purpose of To-Do List
    </ProjectCard>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      